export function getCompanies (state) {
  return state.companies
}

export function getCompany (state) {
  return state.company
}

export function getSimilarCompanies (state) {
  return state.similar
}

export function getCompanyVacancies (state) {
  return state.vacancies
}



// WEBPACK FOOTER //
// ./src/vuex/companies/getters.js